import axios from "axios";
import Cookies from "js-cookie";
import RecHome from "../components/recruiter/org_home/rec_home/RecHome";
import SbHome from "../components/recruiter/org_home/smallbiz_home/SbHome";
import { useEffect, useState } from "react";

export default function OrgProfile() {
    const [role, setRole] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRole = async () => {
            try {
                const userId = Cookies.get("id");
                const userResponse = await axios.get(`/api/users/${userId}/`, { withCredentials: true });

                if (userResponse.data?.role) {
                    setRole(userResponse.data.role);
                }

            } catch (error) {
                console.error("Error fetching role", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRole();
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen w-screen">
                <div className="flex flex-col items-center space-y-2">
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    return (
        <RecHome />
    );
}